export class ViewModel {
    constructor(config) {
        this.config = config;
    }
}
